@if (hasUninvitedParticipants()) {
  <p-button
    [label]="'common.sendInvitation' | transloco"
    icon="pi pi-send"
    [loading]="sending()"
    (onClick)="openDialog()"
  />
}

<p-dialog
  [visible]="dialogVisible()"
  (visibleChange)="dialogVisible.set($event)"
  [modal]="true"
  [draggable]="false"
  [style]="{width: '450px'}"
>
  <ng-template #header>
    <h3 class="text-lg font-semibold">
      {{
        (isFirstInvitation()
          ? 'project.steps.invitationList.confirmDialog.titleFirstInvitation'
          : 'project.steps.invitationList.confirmDialog.title'
        ) | transloco: {phase: phase()}
      }}
    </h3>
  </ng-template>

  <div class="flex flex-col gap-4">
    <p>
      {{
        (isFirstInvitation()
          ? 'project.steps.invitationList.confirmDialog.messageFirstInvitation'
          : 'project.steps.invitationList.confirmDialog.message'
        ) | transloco: {phase: phase()}
      }}
    </p>

    <app-model-field-datepicker
      id="submission-date"
      label="project.steps.invitationList.plannedSubmissionDate"
      [smallLabel]="true"
      [isRequired]="true"
      [minDate]="submissionDateMin()"
      [maxDate]="submissionDateMax()"
      [value]="selectedDate()"
      (valueChange)="selectedDate.set($event)"
    />

    <div class="flex justify-end gap-3">
      <p-button
        severity="secondary"
        [outlined]="true"
        [label]="'common.cancel' | transloco"
        (onClick)="closeDialog()"
      />
      <p-button
        [label]="'common.confirm' | transloco"
        [loading]="sending()"
        [disabled]="!selectedDate()"
        (onClick)="confirmSend()"
      />
    </div>
  </div>
</p-dialog>
